var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSellingFeatures)?_c('div',{staticClass:"sell",class:{
    'sell-pc': _vm.showPc,
    'sell-default':_vm.theme == 'default'
  }},_vm._l((_vm.sellingFeatures),function(item,index){return _c('div',{key:index,staticClass:"sell-item",class:{'center':_vm.typographicStyle=='center'}},[(item.text)?_c('p',[_c('i',{staticClass:"iconfont",class:[("icon-cm-" + (item.icon))]}),_vm._v(" "),_c('span',{staticClass:"page_text_font"},[_vm._v(_vm._s(item.text))])]):_vm._e()])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }